import styled from '@emotion/styled';
import { Link } from '@naf-simba/elements-links';
import { breakpoints, spacing } from '@naf/theme';
import { GridRow } from '@naf/grid';

export const StyledButtonLink = styled(Link)`
  margin-bottom: ${spacing.space32};
`;

export const DiscountWrapper = styled.div`
  margin-bottom: ${spacing.space32};
`;

export const MobileWrapper = styled.div<{ $extraMargin?: boolean }>`
  display: none;

  @media (max-width: ${breakpoints.m}) {
    display: block;
    margin-top: ${({ $extraMargin }) => ($extraMargin ? spacing.space40 : 0)};
  }
`;

export const DesktopWrapper = styled.div<{ $marginTop?: boolean }>`
  display: block;
  margin-top: ${({ $marginTop }) => ($marginTop ? spacing.space40 : 0)};

  @media (max-width: ${breakpoints.m}) {
    display: none;
  }
`;

export const BenefitWrapper = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 ${spacing.space16};

  @media (min-width: 1440px) {
    padding: 0;
  }
`;

export const BenefitContent = styled.div`
  padding: 0 ${spacing.space64};

  @media (max-width: ${breakpoints.l}) {
    padding: 0;
  }
`;

export const StyledGridRow = styled(GridRow)`
  padding-top: ${spacing.space48};

  @media (max-width: ${breakpoints.m}) {
    padding-top: ${spacing.space32};
  }
`;

export const BenefitDiscountCopyWrapper = styled.div`
  display: flex;
  margin-bottom: ${spacing.space32};
`;

export const CampaignDiscountWrapper = styled.div`
  display: flex;
  gap: ${spacing.space16};
`;
